import { gql } from '@apollo/client';

export const CHANGE_SUBSCRIPTION = gql`
  mutation ChangeSubscription(
    $plan: PlanEnum!
    $recurringInterval: RecurringIntervalEnum!
    $pmId: String
    $promoCode: String
  ) {
    changeSubscription(
      plan: $plan
      recurringInterval: $recurringInterval
      pmId: $pmId
      promoCode: $promoCode
    ) {
      message
    }
  }
`;

export const REACTIVATE_CANCELLED_SUBSCRIPTION = gql`
  mutation ReactivateCancelledSubscription {
    reactivateCancelledSubscription {
      message
    }
  }
`;

export const UPDATE_SUBSCRIPTION_FROM_STRIPE = gql`
  mutation UpdateSubscriptionFromStripe {
    updateSubscriptionFromStripe {
      message
    }
  }
`;

export const DELETE_SUBSCRIPTION = gql`
  mutation DeleteSubscription {
    deleteSubscription {
      message
    }
  }
`;

export const PREVIEW_SUBSCRIPTION_DISCOUNT = gql`
  mutation PreviewSubscriptionDiscount(
    $plan: PlanEnum!
    $recurringInterval: RecurringIntervalEnum!
    $promoCode: String!
  ) {
    previewSubscriptionDiscount(
      plan: $plan
      recurringInterval: $recurringInterval
      promoCode: $promoCode
    ) {
      amount
      name
    }
  }
`;

export const REQUEST_CUSTOM_PLAN = gql`
  mutation RequestCustomPlan($message: String!) {
    requestCustomPlan(message: $message) {
      message
    }
  }
`;
